import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./AdminOfficialBusiness.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import OfficialBusinessLayout from "../../layouts/Admin/OfficialBusinessLayout";

const AdminOfficialBusiness = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <OfficialBusinessLayout />
    </>
  );
};

export default AdminOfficialBusiness;
